import { form2, getDiffMonths } from '@pulseops/common'
import * as t from 'io-ts'
import { NonEmptyString, withMessage } from 'io-ts-types'
import { pipe } from 'fp-ts/function'
import moment from 'moment'
import i18next from 'i18next'

export namespace RiderReinstatementForm {
  const FileMeta = t.type({
    fileName: t.string,
    fileExtension: t.string,
    size: t.number,
    base64: t.string,
    uploadedDate: form2.date.required,
    file: form2.file.required
  })

  export type FileMeta = t.TypeOf<typeof FileMeta>

  export const RiderDetail = t.type({
    coverageCode: t.string,
    riskCommDate: t.string,
    lapsedDate: t.string,
    sumAssured: t.number,
    riderPremium: t.number,
  })

  export type RiderDetail = t.TypeOf<typeof RiderDetail>

  const ReinDetail = t.intersection([
    t.type({
      name: t.string,
      clientNum: form2.string.optional,
      healthAnswer: t.boolean,
      occupationAnswer: t.boolean,
      activitiesAnswer: t.boolean,
      companyAnswer: t.boolean,
      curOccupation: withMessage(form2.selectOption.required, () => 'This form required'),
      agentCode: t.string,
      riderList: t.array(RiderDetail)
    }),
    t.union([
      t.type({
        occupationAnswer: t.literal(false)
      }),
      t.type({
        occupationAnswer: t.literal(true),
        newOccupation: withMessage(form2.selectOption.required, () =>
          i18next.t('message:MS020001', { field: i18next.t('submission:NewOccupation').toLowerCase() })
        )
      })
    ]),
    t.union([
      t.type({
        activitiesAnswer: t.literal(false)
      }),
      t.type({
        activitiesAnswer: t.literal(true),
        newActivity: withMessage(NonEmptyString, () =>
          i18next.t('message:MS020001', { field: i18next.t('submission:NewActivity').toLowerCase() })
        )
      })
    ]),
    t.union([
      t.type({
        companyAnswer: t.literal(false)
      }),
      t.type({
        companyAnswer: t.literal(true),
        newCompany: withMessage(NonEmptyString, () =>
          i18next.t('message:MS020001', { field: i18next.t('submission:CompanyName').toLowerCase() })
        )
      })
    ])
  ])

  export type ReinDetail = t.TypeOf<typeof ReinDetail>

  const FormRein = t.type({
    reinFee: t.number,
    lifeAssuredList: t.array(ReinDetail),
    attachmentFiles: t.array(FileMeta)
  })
  export type FormRein = t.TypeOf<typeof FormRein>

  export const checkRequiredAttachment = (
    reinDetails: ReinDetail[],
    attachmentFiles: FileMeta[],
  ) => {
    if (reinDetails.some((c) => c.healthAnswer)) {
      return !!attachmentFiles && attachmentFiles.length >= 1
    }
    return true
  }

  type AttacthmentBrand = {
    readonly AttachmentsCheck: unique symbol
  }
  /* 
    check file declaration file upload
    */
  export type AttachmentsCheck = t.Branded<FormRein, AttacthmentBrand>

  const AttachmentsCheck = pipe(
    FormRein,
    form2.refine(
      (l): l is AttachmentsCheck =>
        checkRequiredAttachment(l.lifeAssuredList, l.attachmentFiles),
      (l) => i18next.t('message:MS050232'),
      'AttachmentsCheck'
    )
  )

  export const codec = t.type({
    formRein: AttachmentsCheck
  })

  export type Validated = t.TypeOf<typeof codec>

  export type Raw = t.OutputOf<typeof codec>
}
